import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=7cc53124&scoped=true&lang=pug&"
import script from "./Event.vue?vue&type=script&lang=js&"
export * from "./Event.vue?vue&type=script&lang=js&"
import style0 from "./Event.scss?vue&type=style&index=0&id=7cc53124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc53124",
  null
  
)

export default component.exports